module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "grey lighten-4 elevation-3"
  }, [_c('v-card-title', {
    staticClass: "subheading"
  }, [_vm._v("Banca " + _vm._s(_vm.exam.id))]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', {
    attrs: {
      "three-line": ""
    }
  }, _vm._l((_vm.headers), function(header, i) {
    return _c('v-list-tile', {
      key: header.key
    }, [_c('v-list-tile-content', [_vm._v(_vm._s(header.title) + ":")]), _vm._v(" "), _c('v-list-tile-content', {
      staticClass: "align-end",
      staticStyle: {
        "max-width": "80%"
      }
    }, [(typeof header.formatter === 'undefined') ? [(i == 0) ? _c('p', _vm._l((_vm.exam.studentName), function(nome) {
      return _c('span', [_vm._v(_vm._s(nome))])
    }), 0) : _c('p', [_vm._v(_vm._s(_vm.exam[header.key]))])] : [_vm._v("\n                    " + _vm._s(header.formatter(_vm.exam)) + "\n                ")]], 2)], 1)
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ab97a6f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExamDetailList.vue
// module id = 251
// module chunks = 0